import { useEffect, useRef, useState } from "react";

/**
 * Lanyard Discord Presence hook using WebSocket.
 * Docs: https://github.com/Phineas/lanyard
 */
export default function useLanyard(userId) {
  const [data, setData] = useState(null);
  const [connected, setConnected] = useState(false);
  const wsRef = useRef(null);
  const heartbeatRef = useRef(null);

  useEffect(() => {
    if (!userId) return;
    let closed = false;

    function connect() {
      const ws = new WebSocket("wss://api.lanyard.rest/socket");
      wsRef.current = ws;

      ws.onmessage = (event) => {
        const payload = JSON.parse(event.data);
        // OP 1 = Hello. Send OP 2 with subscribe_to_id
        if (payload.op === 1) {
          const heartbeatInterval = payload.d.heartbeat_interval;
          ws.send(
            JSON.stringify({
              op: 2,
              d: { subscribe_to_id: userId },
            })
          );
          heartbeatRef.current = setInterval(() => {
            if (ws.readyState === WebSocket.OPEN) {
              ws.send(JSON.stringify({ op: 3 }));
            }
          }, heartbeatInterval);
        } else if (payload.op === 0) {
          // INIT_STATE or PRESENCE_UPDATE
          if (payload.t === "INIT_STATE") {
            setData(payload.d);
            setConnected(true);
          } else if (payload.t === "PRESENCE_UPDATE") {
            setData(payload.d);
          }
        }
      };

      ws.onclose = () => {
        setConnected(false);
        if (heartbeatRef.current) clearInterval(heartbeatRef.current);
        if (!closed) setTimeout(connect, 3000);
      };

      ws.onerror = () => {
        ws.close();
      };
    }

    connect();

    return () => {
      closed = true;
      if (heartbeatRef.current) clearInterval(heartbeatRef.current);
      if (wsRef.current) wsRef.current.close();
    };
  }, [userId]);

  return { data, connected };
}
